import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.5 38q-.65 0-1.075-.425Q10 37.15 10 36.5V19.7q0-.65.425-1.075.425-.425 1.075-.425.65 0 1.075.425Q13 19.05 13 19.7v13.2L36.85 9.05q.45-.45 1.05-.45.6 0 1.05.45.45.45.45 1.05 0 .6-.45 1.05L15.1 35h13.2q.65 0 1.075.425.425.425.425 1.075 0 .65-.425 1.075Q28.95 38 28.3 38Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }